var site = site || {};
var generic = generic || {};

site.foundationFinder = site.foundationFinder || {};

(function ($) {
  Drupal.behaviors.foundationFinderV1 = {
    attach: function (context) {
      this.init(context);
    },
    init: function (context) {
      var self = this;
      var pageDataResult = page_data && page_data['product-input-type'] ? page_data['product-input-type'].products : '';
      var skinToneData = [];
      var underToneData = [];
      var coverageData = [];
      var formData = [];
      var finishData = [];
      var skinGoal1Data = [];
      var skinGoal2Data = [];
      var recomendedProducts = [];
      var resultRecomended = [];
      var $template = $('#foundation-finder-quiz', context);
      var $results = $('.foundation-finder-results', $template);
      var $resultsContainer = $('.foundation-finder-results__recommended-products', $results);
      var $nav = $('.ff-quiz__header', $template);
      var $navItems = $('.ff-quiz__nav-item', $template);
      var $carousel = $('.ff-quiz__carousel', $template);
      var $slides = $('.ff-quiz__slide', $template);
      var $answers = $('[data-answer]', $template);
      var $startBtn = $('.ff-quiz__button--start', $template);
      var $nextBtn = $('.ff-quiz__button--next', $template);
      var $filterBtn = $('.ff-quiz__filter-button', $template);
      var $resetBtn = $('.ff-quiz__start-over-link', $template);
      var $underTonePopupLink = $('#underTonePopupLink', $template);
      var $closeButton = $('#closeButton', $template);
      var $ffForEle = $('[ff_for]', $template);
      var $skinTone = $('.foundation-finder_skintone_selection img', $template);
      var $underTone = $('.foundation-finder_undertone_selection input, .foundation-finder_undertone_selection a.selection_skip', $template);
      var $coverage = $('.foundation-finder_coverage input , .foundation-finder_coverage a', $template);
      var $ffForm = $('.foundation-finder_form-selection input, .foundation-finder_form-selection a', $template);
      var $finish = $('.foundation-finder_finish-selection input, .foundation-finder_finish-selection a', $template);
      var $skin_1_goal = $('.skin-goal-one input ,.skin-goal-one a', $template);
      var $skin_2_goal = $('.skin-goal-two input ,.skin-goal-two a', $template);
      var $start_over = $('.start-over-link', $template);
      var $carousel2 = $('.ff-quiz__gallery', $template);
      var $default_slide_index = parseInt($('.ff-quiz__gallery', $template).attr('data-default-slide'));
      var $carousel2PreviousBtn = $('.ff-quiz__gallery-arrow--prev', $template);
      var $carousel2NextBtn = $('.ff-quiz__gallery-arrow--next', $template);
      var $privacyPolicyLink = $('.js-ff-quiz__legal a', $template);
      var isTablet = false; // parseInt(bp.width, 10) >= parseInt(bps.portrait, 10);
      var itemCount = $navItems.length;
      var slideIndex = 1;
      var slideSpeed = 500;
      var isMobile = site.client.isMobile || false;
      var rtlMobile = false;
      var rtlPC = false;
      var pageDirection = $template.closest('html').attr('dir');

      $carousel2.find('a').attr('data-test-id', 'slider_2');
      $coverage.attr('data-test-id', 'slider_1');

      // Check site direction 
      if (pageDirection === 'rtl') {
        rtlPC = true;
        if (isMobile) {
          rtlMobile = true;
        }
      }

      $skinTone.on('click', function (event) {
        var skin_tone_ans = $(event.target).attr('data-answer');

        skinToneData = self.filterSkuLevel($.extend(true, {}, pageDataResult), 'SKIN_TONE_REFINEMENT_2', skin_tone_ans);
      });

      $underTone.on('click', function (event) {
        var under_tone_ans = $(event.target).attr('data-answer');

        // underToneData = (under_tone_ans != '') ? self.filterSkuLevel($.extend( true, {}, skinToneData), "UNDERTONE", under_tone_ans) : skinToneData;
        // Remove undertone from the filter logic
        underToneData = $.extend(true, {}, skinToneData);
      });

      $coverage.on('click', function (event) {
        var coverage_ans = $(event.target).attr('data-answer');

        coverageData = coverage_ans != '' ? self.filterProdLevel($.extend(true, {}, skinToneData), 'ATTRIBUTE_COVERAGE_2', coverage_ans) : skinToneData;
        resultRecomended = coverageData;
      });

      $ffForm.on('click', function (event) {
        var form_ans = $(event.target).attr('data-answer');

        formData = form_ans != '' ? self.filterProdLevel($.extend(true, {}, coverageData), 'FORMULA_2', form_ans) : coverageData;
      });

      $finish.on('click', function (event) {
        var finish_ans = $(event.target).attr('data-answer');

        finishData = finish_ans != '' ? self.filterSkuLevel($.extend(true, {}, formData), 'FINISH_2', finish_ans) : formData;
      });

      $skin_1_goal.on('click', function (event) {
        var skin_1_ans = $(event.target).attr('data-answer');

        skinGoal1Data = skin_1_ans != '' ? self.filterProdLevel($.extend(true, {}, finishData), 'SKIN_GOAL_1', skin_1_ans) : finishData;
      });

      $skin_2_goal.on('click', function (event) {
        var skin_2_ans = $(event.target).attr('data-answer');

        skinGoal2Data = skin_2_ans != '' ? self.filterProdLevel($.extend(true, {}, skinGoal1Data), 'SKIN_GOAL_2', skin_2_ans) : skinGoal1Data;
        if (skin_2_ans != '') {
          $(event.target).addClass('active');
        }
        recomendedProducts = recomendedProducts.length > 5 ? recomendedProducts : skinToneData;
        self.parseResults(skinGoal2Data, recomendedProducts, resultRecomended);
      });
      // Reset quiz
      $resetBtn.on('click', function (event) {
        event.preventDefault();
        location.reload();
      });

      $(document).on('click', '#startOver', function (event) {
        location.reload();
      });

      $(document).on('click', '#resultStartOver', function (event) {
        location.reload();
      });

      $(document).on('click', '#close-results', function (event) {
        $('.refine-results-expanded_view').hide();
        $(event.target).hide();
      });

      $(document).on('click', '.refine-my-results', function (event) {
        $('#close-results').show();
        $('.refine-results-expanded_view').show();
      });

      $privacyPolicyLink.on('click', function (event) {
        event.stopPropagation();
      });

      // Set all slides to match tallest slide
      if (isTablet) {
        $slides.matchHeight({
          byRow: false
        });
      }

      // On mobile, carousel fades. On tablet we update to slide up/down
      // Disable all controls that allow user to move to a slide e.g., drag, swipe, etc.
      $carousel.slick({
        rtl: rtlMobile,
        speed: slideSpeed,
        infinite: false,
        swipe: false,
        draggable: false,
        touchMove: false,
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        fade: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              vertical: true,
              adaptiveHeight: false,
              fade: false
            }
          }
        ]
      });

      // Shade Picker Carousel
      $carousel2.slick({
        rtl: rtlPC,
        lazyLoad: 'ondemand',
        arrows: false,
        initialSlide: $default_slide_index || 8,
        speed: 200,
        slidesToShow: 2,
        slidesToScroll: 2,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              infinite: true,
              speed: 300,
              variableWidth: true,
              slidesToShow: 5,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              speed: 300,
              variableWidth: true,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      });

      $carousel2PreviousBtn.on('click', function() {
        $carousel2.slick('slickPrev');
      });
      $carousel2NextBtn.on('click', function() {
        $carousel2.slick('slickNext');
      });

      // Workaround for known bug: carousel nested inside another carousel both trigger the same events
      // https://github.com/kenwheeler/slick/issues/1179#issuecomment-85999437
      $carousel2.on('beforeChange', function (event) {
        event.stopPropagation();
      });
      $carousel2.on('afterChange', function (event) {
        event.stopPropagation();
      });

      $carousel.on('beforeChange', function () {
        $nextBtn.removeClass('active');
        $('html, body').animate({
          scrollTop: 0
        }, 300);
      });

      $carousel.on('afterChange', function (event, slick, currentSlide) {
        slideIndex = currentSlide;
        $navItems.removeClass('active').filter('.ff-quiz__nav-item--' + slideIndex).addClass('active').addClass('selected');
        // If current slide already has a question answered, show next button
        if ($('.slick-active .ff-quiz__answer').hasClass('active')) {
          $nextBtn.toggleClass('ff-quiz__button--results', slideIndex === itemCount).addClass('active');
        }

        $('#stepNum').text(slideIndex);
        $('#mobSelHdrTxt').text($('.active .ff-quiz__nav-text', $('.ff-quiz__nav-menu')).text());

        if (slideIndex == 3) {
          $coverage.each(function (ind, item) {
            var coverage_qs = $(item).attr('data-answer');

            if (coverage_qs != '') {
              var coverage_count = $.grep(skinToneData, function (n, i) {
                var coverageAtr = n.ATTRIBUTE_COVERAGE_2 ? n.ATTRIBUTE_COVERAGE_2 : '';

                return self.greyOutQuestion(coverageAtr, coverage_qs);
              });
              var disableItem = $(this).parent().parent();

              self.disableQuestion(coverage_count, disableItem);
            }
          });
        } else if (slideIndex == 4) {
          $ffForm.each(function (ind, item) {
            var form_qs = $(item).attr('data-answer');

            if (form_qs != '') {
              var form_count = $.grep(coverageData, function (n, i) {
                var formAtr = n.FORMULA_2 ? n.FORMULA_2 : '';

                return self.greyOutQuestion(formAtr, form_qs);
              });
              var disableItem = $(this).parent();

              self.disableQuestion(form_count, disableItem);
            }
          });
        } else if (slideIndex == 5) {
          $finish.each(function (ind, item) {
            var finish_skus = [];
            var finish_qs = $(item).attr('data-answer');

            if (finish_qs != '') {
              finish_qs = finish_qs.replace('-', ' ');
              $.each(formData, function (index, item) {
                var finish_count = $.grep(item['skus'], function (n, i) {
                  var finishAtr = n.FINISH_2 ? n.FINISH_2.replace('-', ' ') : '';

                  return self.greyOutQuestion(finishAtr, finish_qs);
                });

                if (finish_count.length > 0) {
                  finish_skus.push(finish_count);
                }
              });
              var disableItem = $(this).parent();

              self.disableQuestion(finish_skus, disableItem);
            }
          });
        } else if (slideIndex == 6) {
          $skin_1_goal.each(function (ind, item) {
            var skin_1_goal_qs = $(item).attr('data-answer');

            if (skin_1_goal_qs != '') {
              var skin_1_goal_count = $.grep(finishData, function (n, i) {
                var skinGoalAttr = n.SKIN_GOAL_1 ? n.SKIN_GOAL_1 : '';

                return self.greyOutQuestion(skinGoalAttr, skin_1_goal_qs);
              });
              var disableItem = $(this).parent();

              self.disableQuestion(skin_1_goal_count, disableItem);
            }
          });
        } else if (slideIndex == 7) {
          var i = 0;
          var j = 0;

          $skin_2_goal.each(function (ind, item) {
            var skin_2_goal_qs = $(item).attr('data-answer');
            var skin_1_ans = $('.skin-goal-one input.active').attr('data-answer');
            var disableItem = $(this).parent();

            if (skin_2_goal_qs != '') {
              if (skin_1_ans && skin_1_ans.toLowerCase().trim() === skin_2_goal_qs.toLowerCase().trim()) {
                disableItem.addClass('ff-disabled');
                i++;
              } else {
                var skin_2_goal_count = $.grep(skinGoal1Data, function (n, i) {
                  var skinGoal2Attr = n.SKIN_GOAL_2 ? n.SKIN_GOAL_2 : '';

                  return self.greyOutQuestion(skinGoal2Attr, skin_2_goal_qs);
                });

                if (skin_2_goal_count.length == 0) {
                  i++;
                }
                self.disableQuestion(skin_2_goal_count, disableItem);
              }
            }
            j = ind;
          });
          if (i == j) {
            $('.skin-goal-two a', $template).trigger('click');
          }
        }
      });

      // Start Quiz
      $startBtn.on('click', function(event) {
        event.preventDefault();
        $carousel.slick('slickGoTo', 1);
        // On After slide change
        $carousel.on('afterChange', function (event, slick, currentSlide) {
          slideIndex = currentSlide;
          $nav.addClass('active');
          $('.foundation-finder-mobile-view__header').addClass('showHdr');
        });
      });

      $('.ff-quiz input[type=radio]').picker();

      $underTonePopupLink.on('click', function (event) {
        $('.foundation-finder_undertone_selection').hide();
        $('#ff_quiz_undertone_popup').show();
      });

      $closeButton.on('click', function (event) {
        $('.foundation-finder_undertone_selection').show();
        $('#ff_quiz_undertone_popup').hide();
      });

      // Do something when a question is answered
      $answers.on('click', function (event) {
        self.answerAction($(this), $navItems, $nextBtn, slideIndex, itemCount, $carousel);
        self.clearFields(slideIndex);
      });

      $(document).off('click', '.foundation-finder_skintone_selection [data-answer]').on('click', '.foundation-finder_skintone_selection [data-answer]', function (event) {
        self.answerAction($(this), $navItems, $nextBtn, slideIndex, itemCount, $carousel);
        self.clearFields(slideIndex);
      });

      $ffForEle.on('click', function (event) {
        var clickedTag = event.target.tagName;

        if (clickedTag != 'INPUT' && clickedTag != 'LABEL') {
          $('#' + $(event.target).attr('ff_for')).trigger('click');
        }
      });

      // Navigation breadcrumbs
      $(document).on('click', '.ff-quiz__nav-item', function (event) {
        event.preventDefault();
        var index = $(this).index();

        if ($(this).parent().parent().hasClass('refine-results-expanded_view')) {
          $('.foundation-finder-results').addClass('hidden');
          $('.ff-quiz').show();
          $(this).parent().find('.ff-quiz__nav-item').addClass('selected');
        }
        if ($(this).hasClass('selected')) {
          if (!$(this).hasClass('active')) {
            $carousel.slick('slickGoTo', index + 1);
            $('#stepNum').text(index + 1);
            self.clearFields(index);
          }
        }
      });

      // Go to next slide

      $nextBtn.on('click', function(event) {
        // Go to the next slide if we're not already on the last slide:
        if (slideIndex !== itemCount) {
          $carousel.slick('slickNext');
        }
      });

      $('body').mouseup(function () {
        $('#mobileBC').removeClass('show').addClass('hide');
      });
      $('.progress-preview-dropdown').on('click', function() {
        $('#mobileBC').removeClass('hide').addClass('show');
      });
    },
    // Disable the questions based on the previous selection
    disableQuestion: function (itemData, disableItem) {
      if (itemData.length == 0) {
        disableItem.addClass('ff-disabled');
      } else {
        disableItem.removeClass('ff-disabled');
      }
    },
    // Greying out the questions based on the previous selection
    greyOutQuestion: function (itemData, quizAnswer) {
      itemData = itemData.toLowerCase().trim();
      quizAnswer = quizAnswer.toLowerCase().trim();
      var itemDataAttrItems = itemData ? itemData.split(',') : '';

      itemDataAttrItems = itemDataAttrItems ? itemDataAttrItems.map(jQuery.trim) : '';

      return itemData && jQuery.inArray(quizAnswer, itemDataAttrItems) > -1 ? 1 : 0;
    },
    answerAction: function (event, navItems, nextBtn, slideIndex, itemCount, carousel) {
      var $slide = $(event).parentsUntil('.ff-quiz__slide');
      var $navItems = navItems;
      var $nextBtn = nextBtn;
      var slideIndex = slideIndex;
      var itemCount = itemCount;
      var $carousel = carousel;
      var quizNav = $(event);

      $('[data-answer]', $slide).removeClass('active');
      $(event).addClass('active');
      var quizSlideValue = $(event).data('answer');
      var quizQuestion = $(event).attr('name') || $(event).closest('.ff-quiz__slide').find('.ff_slide_content').data('question-key');
      var analyticsObj = {
        'quizLabel': quizQuestion,
        'quizValue': quizSlideValue,
        'quizStep': slideIndex,
        'quizNav': quizNav
      };

      $navItems.eq($slide.index() - 1).addClass('selected');
      $nextBtn.toggleClass('ff-quiz__button--results', slideIndex === itemCount).addClass('active');

      if (slideIndex !== itemCount) {
        $carousel.slick('slickNext');
      }
      $(document).trigger('quiznextStep', analyticsObj);
    },

    // Get the FF quiz results
    getResults: function (results) {
      Drupal.cl.template.get({
        path: 'clinique_finder_result',
        object: results,
        callback: function (html) {
          var $result_content = $(html);

          $('.ff-quiz').hide();
          $('.foundation-finder-results').removeClass('hidden').html($result_content);
          var progressNode = $('span.add-progress', $result_content);
          var addButtonNode = $('.add-to-bag', $result_content);
          var shadeNode = $('.shade-content', $result_content);
          var recomendedSection = $('.more-matches li', $result_content);
          var signedIn = parseInt(site.userInfoCookie.getValue('signed_in'));
          var isLoyaltyMember = parseInt(site.userInfoCookie.getValue('is_loyalty_member'));
          var siteUrlLoyalty = window.location.href;
          var validLoyalty = 'foundation-finder';
          var paramObj = {
            'offer_code': 'lyl_foundation_finder',
            'do_not_defer_messages': 1
          };

          // Display the shades
          shadeNode.first().addClass('active');
          if (recomendedSection.length == 0) {
            $('.more-matches', $result_content).hide();
          }
          shadeNode.each(function (index, shade) {
            $(this).on('click', function (e) {
              shadeNode.removeClass('active');
              var sku_base_id = $(this).attr('data-sku');
              var price = $(this).attr('data-price');
              var shade_name = $(this).attr('data-shade');

              $('.add-to-bag', $result_content).attr('data-skubaseid', sku_base_id);
              $('.shade_name', $result_content).html(shade_name);
              $('.price', $result_content).html(price);
              $(this).addClass('active');
            });
          });
          addButtonNode.unbind();
          // Add to bag
          addButtonNode.on('click', function (e) {
            e.preventDefault();
            var skuBaseId = addButtonNode.attr('data-skubaseid');

            if (progressNode.length) {
              addButtonNode.hide();
              progressNode.show();
              $(document).one('addToCart.success addToCart.failure', function () {
                progressNode.hide();
                addButtonNode.show();
              });
            }
            site.addToCart({
              skuBaseId: $(this).attr('data-skubaseid')
            });
          });

          // if the user is signed in and a loyalty member apply the Foundation finder offer
          if (signedIn && isLoyaltyMember && (siteUrlLoyalty.indexOf(validLoyalty) !== -1)) {
            generic.jsonrpc.fetch({
              method: 'offers.apply',
              params: [paramObj]
            });
          }

          $('.foundation-finder-save').on('click', function (event) {
            event.preventDefault();

            var SKUIDS = [];
            var i;

            for (i = 0; i < results.skus.length; ++i) {
              SKUIDS.push(results.skus[i].SKU_ID);
            }
            var param = {
              'ProductID': results.PRODUCT_ID,
              'SKUIDS': SKUIDS
            };
            var param_data = {
              'type': 'foundation_finder',
              'data': param
            };

            $.cookie('ff_quiz_flag', 1);
            $.cookie('ff_quiz_result', JSON.stringify(param));
            if (typeof generic.user == 'object' && generic.user.isSignedIn()) {
              generic.jsonrpc.fetch({
                method: 'quiz.save',
                params: param_data,
                onSuccess: function (jsonRpcResponse) {
                  var host = window.location.hostname;
                  var target = '';

                  target = 'https://' + host + '/account/diagnostics.tmpl';
                  var form = document.createElement('form');

                  form.setAttribute('method', 'post');
                  form.setAttribute('action', target);
                  form.setAttribute('type', 'hidden');
                  document.body.appendChild(form);
                  form.trigger('submit');
                }
              });
            } else {
              generic.jsonrpc.fetch({
                method: 'quiz.cache',
                params: param_data,
                onSuccess: function (jsonRpcResponse) {
                  var host = window.location.hostname;
                  var target = '';

                  target = 'https://' + host + '/account/signin.tmpl?RETURN_URL=/account/diagnostics.tmpl';
                  var form = document.createElement('form');

                  form.setAttribute('method', 'post');
                  form.setAttribute('action', target);
                  form.setAttribute('type', 'hidden');
                  document.body.appendChild(form);
                  form.trigger('submit');
                }
              });
            }
          });
          $('[data-question-key]').each(function (qind, qItemEle) {
            var questionKey = $(qItemEle).data('question-key');
            var defaultanswer = $('#ref_' + questionKey).html();
            var arrowlink = $('#ref_' + questionKey).parent().find('.arrow-link').clone();
            var answerVal = $('[data-answer].active', qItemEle).data('answer');

            if (answerVal) {
              $('#ref_' + questionKey).text(answerVal.toUpperCase());
            } else {
              $('#ref_' + questionKey).text(defaultanswer);
            }
            $('#ref_' + questionKey).append(arrowlink);
            $('#ref_' + questionKey).find('.arrow-link').removeClass('hidden');
          });
          $('#close-results').trigger('click');
        }
      });
      $(document).trigger('filterResult');
    },

    // Get the FF quiz results
    noResults: function (no_result) {
      Drupal.cl.template.get({
        path: 'clinique_finder_no_result',
        object: no_result,
        callback: function (html) {
          var $html = $(html);

          $('.ff-quiz').hide();
          $('.foundation-finder-results').removeClass('hidden').html($html);
        }
      });
      $(document).trigger('filterResult');
    },
    // To parse the quiz results.
    parseResults: function (result, recomendedProducts, resultRecomended) {
      var self = this;
      var parsedResult = [];
      var quizResult = [];
      var productFields = ['FAMILY_CODE', 'IMAGE_3UP', 'PRODUCT_ID', 'DEFAULT_CAT_ID', 'PARENT_CAT_ID', 'PROD_RGN_NAME', 'PROD_RGN_SUBHEADING', 'SUB_LINE', 'THUMBNAIL_IMAGE', 'shaded', 'sized', 'url', 'skus', 'priceRange', 'isDisplayable', 'TOTAL_REVIEW_COUNT'];
      var skuFields = ['isOrderable', 'WWW_PCODE', 'SMOOSH_PATH_STRING', 'HEX_VALUE_STRING', 'INVENTORY_STATUS', 'SKU_ID', 'SKU_BASE_ID', 'PRODUCT_ID', 'SHADENAME', 'PRICE', 'formattedPrice', 'SMALL_IMAGE', 'UNDERTONE', 'SKIN_TONE', 'PRODUCT_SIZE', 'PRODUCT_CODE'];
      // More result or no result

      if (result.length == 0 || result.length > 2) {
        quizResult['products'] = recomendedProducts;
        self.noResults(quizResult);
      } else { // Exact one result */
        /* $.each(result, function(index, item) {
          if (index > 0 ) {
            parsedResult.push(item);
          }
        }); */
        quizResult = $.extend(true, {}, result[0]);
        if (quizResult.skus.length < 3) {
          var prod_param = [
            {
              'products': quizResult.PRODUCT_ID,
              'category_fields': ['products'],
              'product_fields': productFields,
              'sku_fields': skuFields,
              'get_product': 1
            }
          ];

          generic.jsonrpc.fetch({
            'method': 'prodcat',
            'params': prod_param,
            onSuccess: function (jsonRpcResponse) {
              var skuIds = '';
              var secondaryProductData = jsonRpcResponse.getValue().products;

              if (secondaryProductData[0].skus.length > 0) {
                for (var i = 0; i < quizResult.skus.length; i++) {
                  skuIds = skuIds + quizResult.skus[i].SKU_ID;
                }
                if (secondaryProductData.length) {
                  var before = 0;
                  var found = 0;

                  for (var i = 0; i < secondaryProductData[0].skus.length; i++) {
                    if (secondaryProductData[0].skus[i].isOrderable == 0) {
                      secondaryProductData[0].skus.splice(i, 1);
                    }
                  }
                  for (var i = 0; i < secondaryProductData[0].skus.length; i++) {
                    var regex = new RegExp(secondaryProductData[0].skus[i].SKU_ID, 'gi');

                    if (skuIds.match(regex)) {
                      secondaryProductData[0].skus.splice(i, 1);
                      i--;
                      found++;
                      if (found >= quizResult.skus.length) {
                        break;
                      }
                      continue;
                    } else if (secondaryProductData[0].skus[i].isOrderable == 0) {
                      secondaryProductData[0].skus.splice(i, 1);
                      i--;
                    }
                    before = i;
                  }
                  if (quizResult.skus.length == 1) {
                    if (before == 0) {
                      quizResult.skus.push(secondaryProductData[0].skus[0]);
                      quizResult.skus.push(secondaryProductData[0].skus[1]);
                    } else if (before == (secondaryProductData[0].skus.length - 1)) {
                      quizResult.skus.push(secondaryProductData[0].skus[before]);
                      quizResult.skus.push(secondaryProductData[0].skus[before - 1]);
                    } else {
                      quizResult.skus.push(secondaryProductData[0].skus[before]);
                      quizResult.skus.push(secondaryProductData[0].skus[before + 1]);
                    }
                  } else if (quizResult.skus.length == 2) {
                    if (before == 0) {
                      quizResult.skus.push(secondaryProductData[0].skus[0]);
                    } else if (before == (secondaryProductData[0].skus.length - 1)) {
                      quizResult.skus.push(secondaryProductData[0].skus[before - 1]);
                    } else {
                      quizResult.skus.push(secondaryProductData[0].skus[before + 1]);
                    }
                  }
                }
              }
              self.getRecommendedProducts(quizResult, productFields, skuFields);
            },
            onFailure: function (jsonRpcResponse) {
              console.log('error');
            }
          });
        } else {
          self.getRecommendedProducts(quizResult, productFields, skuFields);
        }
      }
    },
    getRecommendedProducts: function (quizResult, productFields, skuFields) {
      var self = this;
      // Get recomended products based on the product WWW_PCODE
      var pCode = quizResult.skus[0].WWW_PCODE ? quizResult.skus[0].WWW_PCODE : '';

      if (pCode) {
        var recommendedSkus = $.map(pCode, function (value, index) {
          if ($.trim(value)) {
            return $.trim(value);
          }
        });

        if (recommendedSkus.length > 0) {
          var prod_param = [
            {
              'skus': recommendedSkus,
              'category_fields': ['products'],
              'product_fields': productFields,
              'sku_fields': skuFields,
              'get_product': 1
            }
          ];

          generic.jsonrpc.fetch({
            'method': 'prodcat',
            'params': prod_param,
            onSuccess: function (jsonRpcResponse) {
              var recommResult = jsonRpcResponse.getValue().products ? jsonRpcResponse.getValue().products : '';

              quizResult['recomend_products'] = self.parseRecommendedResults(recommResult, recommendedSkus);
              self.getResults(quizResult);
            },
            onFailure: function (jsonRpcResponse) {
              if (jsonRpcResponse.getValue().products && jsonRpcResponse.getValue().products.length > 0) {
                var recommResult = jsonRpcResponse.getValue().products;

                quizResult['recomend_products'] = self.parseRecommendedResults(recommResult, recommendedSkus);
                self.getResults(quizResult);
              }
            }
          });
        } else {
          self.getResults(quizResult);
        }
      }
    },

    parseRecommendedResults: function (recommResult, recommendedSkus) {
      var recomData = [];
      var recomProducts = [];
      var i = 0;

      $.each(recommResult, function (prodInd, prodListItem) {
        var recommSkus = [];

        $(prodListItem['skus']).each(function (skusInd, skusListItem) {
          if (($.inArray(skusListItem.PRODUCT_CODE, recommendedSkus) > -1) && (skusListItem.isOrderable == 1)) {
            recommSkus.push(skusListItem);
          }
        });
        if (recommSkus.length > 0) {
          var recommCount = $.grep(recomProducts, function (n, i) {
            return n.PRODUCT_ID == prodListItem.PRODUCT_ID;
          });

          if (recommCount.length == 0) {
            recomProducts.push(prodListItem);
          }
          i++;
        }
      });
      recomProducts = recomProducts.slice(0, 3);

      return recomProducts;
    },

    /* To filter the sku based on the filter value
     *  Args : results - Products array
     *  prop - Product cache field name
     *  filterValue - User quiz selection
     */
    filterSkuLevel: function (results, prop, filterValue) {
      if (results) {
        var filterData = [];
        var filterProducts = [];
        var i = 0;

        $.each(results, function (prodInd, prodListItem) {
          var filSkus = [];

          $(prodListItem['skus']).each(function (skusInd, skusListItem) {
            var skuAttrValue = skusListItem[prop] ? skusListItem[prop] : '';

            if (prop == 'SKIN_TONE_REFINEMENT_2') {
              if ((skusListItem.isOrderable === 1) && (skuAttrValue && skuAttrValue.indexOf(filterValue) > -1)) {
                filSkus.push(skusListItem);
              }
            } else {
              if (!skuAttrValue && prop == 'UNDERTONE') {
                filSkus.push(skusListItem);
              } else if (skusListItem[prop]) {
                var skuFilterItems = skusListItem[prop].split(',');

                $.each(skuFilterItems, function (index, ele) {
                  if (ele.toLowerCase().trim() === filterValue.toLowerCase().trim()) {
                    filSkus.push(skusListItem);
                  }
                });
              }
            }
          });
          if (filSkus.length > 0) {
            filterProducts.push(prodListItem);
            filterProducts[i]['skus'] = filSkus;
            i++;
          }
        });

        return filterProducts;
      }
    },
    /* To filter the products based on the filter value
     *  Args : results - Products array
     *  prop - Product cache field name
     *  filterValue - User quiz selection
     */
    filterProdLevel: function (prodData, prop, filterValue) {
      var filterProducts = [];

      $.each(prodData, function (prodInd, prodItem) {
        if (prodItem[prop]) {
          var productFilterItems = prodItem[prop].split(',');

          $.each(productFilterItems, function (index, ele) {
            if (ele.toLowerCase().trim().toLowerCase() === filterValue.trim().toLowerCase()) {
              filterProducts.push(prodItem);
            }
          });
        }
      });

      return filterProducts;
    },
    // To clear the filter data.
    clearFields: function (slideIndex) {
      for (clearItem = slideIndex + 2; clearItem <= 8; clearItem++) {
        $('.ff-quiz__slide--' + clearItem + ' input').each(function (ind, item) {
          $(item).prop('checked', false);
          $('.ff-quiz input[type=radio]').picker('update');
        });
        $('.ff-quiz__nav-item--' + clearItem).each(function (ind, item) {
          $(item).removeClass('selected');
        });
      }
    }
  };
})(jQuery);
